import React from 'react';
import { Helmet } from 'react-helmet';
import RegistrationHeader from './components/RegistrationHeader';
import SocialRegistration from './components/SocialRegistration';
import RegistrationForm from './components/RegistrationForm';
import TrustIndicators from './components/TrustIndicators';

const Register = () => {
  return (
    <>
      <Helmet>
        <title>Register - Share Good | Join the Charitable Giving Community</title>
        <meta name="description" content="Create your Share Good account and start making a difference. Join thousands of donors in supporting verified charities and tracking your impact." />
        <meta name="keywords" content="register, sign up, charity, donation, giving, community, philanthropy" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <div className="flex flex-col items-center justify-center min-h-screen p-4 lg:p-8">
          {/* Centered Registration Form */}
          <div className="w-full max-w-2xl space-y-8">
            <RegistrationHeader />
            <div className="space-y-6">
              <SocialRegistration />
              <RegistrationForm />
            </div>
          </div>

          {/* Trust Indicators Below Form */}
          <div className="w-full max-w-2xl mt-12">
            <div className="bg-muted/20 rounded-lg p-6 lg:p-8">
              <TrustIndicators />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;